module.exports = __webpack_public_path__ + "static/media/Item_01.dae68086.png";